import React from 'react';
import { ShoppingBagIcon } from '@heroicons/react/24/outline';

const CheckoutHeader = () => {
  return (
    <div className="bg-white shadow-md sticky top-0 z-40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-gradient-to-br from-indigo-600 to-purple-600 rounded-xl flex items-center justify-center shadow-lg">
            <ShoppingBagIcon className="h-6 w-6 text-white" />
          </div>
          <div>
            <h1 className="text-xl sm:text-2xl font-bold text-gray-900">Secure Checkout</h1>
            <p className="text-xs sm:text-sm text-gray-500">Complete your vehicle service booking</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckoutHeader;
